/* THIS FILE IS LOCALIZED - IE/UK has no chat */

(function(){
	var loadHeader = new header4i();
	var loadMegaMenu = new megaMenu4i();
	var loadSearch = new search4i();
	var loadChat = new chat4i();

	// initialize header javascript
	loadHeader.init();
	loadMegaMenu.init();
	loadSearch.init();
	loadChat.init();
})();